import React from "react";
import { Helmet } from "react-helmet-async";

const PageTitle = ({ title }) => {
  return (
    <Helmet>
      <title>Uta Koßmagk- Redaktionsbüro</title>
    </Helmet>
  );
};

export default PageTitle;
